export default __webpack_public_path__ + "static/media/400-credits.44428d05.png";